<template>
    <div class="my-container">
        <!-- Card Principal Integrado -->
        <div class="my-card">
            <!-- Header do DataTable -->
            <div class="my-header">
                <div class="header-left">
                    <h1 class="datatable-title">Documentos por Filial</h1>
                    <span class="records-summary">{{ Object.keys(groupedWinners).length }} filial(is)</span>
                </div>
                <div class="header-right">
                    <!-- Espaço para botões futuros se necessário -->
                </div>
            </div>

            <!-- Área de Conteúdo Unificada -->
            <div class="datatable-main-content">
                <!-- Loading State -->
                <div class="datatable-loading" v-if="spinner">
                    <div class="loading-overlay">
                        <div class="loading-spinner">
                            <div class="spinner"></div>
                        </div>
                        <div class="loading-text">
                            <h4>Carregando documentos...</h4>
                            <p>Aguarde enquanto buscamos os dados das filiais</p>
                        </div>
                    </div>
                </div>

                <!-- Conteúdo Principal -->
                <div class="datatable-content" v-else>
                    <!-- Accordion de Filiais -->
                    <div class="modern-accordion" v-if="Object.keys(groupedWinners).length > 0">
                        <div class="accordion-item" v-for="(titles, name, index) in groupedWinners" :key="name">
                            <div class="accordion-header" @click="toggleAccordion(index)">
                                <div class="accordion-title">
                                    <i class="fa fa-building accordion-icon"></i>
                                    <span class="branch-name">{{ name }}</span>
                                    <span class="document-count">{{ titles.length }} documento(s)</span>
                                </div>
                                <div class="accordion-toggle">
                                    <i class="fa fa-chevron-down" :class="{ 'rotated': activeAccordion === index }"></i>
                                </div>
                            </div>
                            <div class="accordion-content" :class="{ 'active': activeAccordion === index }">
                                <div class="accordion-body">
                                    <div class="documents-grid">
                                        <div class="document-item" v-for="title in titles" :key="title.id">
                                            <div class="document-info">
                                                <i class="fa fa-file-alt document-icon"></i>
                                                <span class="document-title">{{ title.title }}</span>
                                            </div>
                                            <router-link :to="'winner-docs-view/' + title.id" class="document-action">
                                                <button class="btn btn-primary btn-action">
                                                    <i class="fa fa-search"></i>
                                                    <span class="btn-text">Visualizar</span>
                                                </button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Estado Vazio -->
                    <div class="empty-state" v-else>
                        <div class="empty-content">
                            <i class="fa fa-inbox empty-icon"></i>
                            <h4>Nenhum documento disponível</h4>
                            <p>Não há documentos cadastrados para as filiais no momento</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer com informações -->
            <div class="datatable-footer">
                <div class="footer-left">
                    <div class="footer-info">
                        <span>Total de filiais: {{ Object.keys(groupedWinners).length }}</span>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="footer-actions">
                        <!-- Espaço para ações futuras -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import axios from "axios";

const toaster = createToaster({
    position: "top-right",
});

export default {
    data() {
        return {
            winners: [],
            spinner: true,
            activeAccordion: null,
        };
    },
    computed: {
        groupedWinners() {
           
           if(Array.isArray(this.winners)){

               const grouped = this.winners.reduce((acc, winner) => {
                   if (!acc[winner.name]) {
                       acc[winner.name] = [];
                   }
                   acc[winner.name].push({ id: winner.id, title: winner.title });
                   return acc;
               }, {});
   
              
               const sortedGrouped = Object.keys(grouped)
                   .sort((a, b) => a.localeCompare(b))
                   .reduce((acc, key) => {
                       acc[key] = grouped[key];
                       return acc;
                   }, {});
   
               return sortedGrouped;
           }
           return [];
        },
    },
    methods: {
        toggleAccordion(index) {
            this.activeAccordion = this.activeAccordion === index ? null : index;
        },
        async getWinners() {
            const self = this;
            const api = this.$store.state.api + "winner-docs/customer-documents";
            if (!self.$store.state.user.customer_id) {
                setTimeout(() => {
                    this.getWinners();
                }, 300);
                return;
            }

            axios
                .get(api)
                .then((response) => {
                    self.winners = response.data;
                })
                .catch((e) => {
                    self.winners = [];
                    console.error(e);
                })
                .finally(() => {
                    self.spinner = false;
                });
        },
    },
    mounted() {
        this.getWinners();
    },
};
</script>

<style scoped>
/* Importando os estilos do BaseTable.vue */

/* DataTable Container */
.my-container {
    padding: 0;
    background: transparent;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

/* Card Principal */
.my-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    border: 1px solid #e9ecef;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

/* Header do DataTable */
.my-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-bottom: 1px solid #e9ecef;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.datatable-title {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: white;
}

.records-summary {
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
}

.header-right {
    display: flex;
    gap: 8px;
}

/* Container Principal Unificado */
.datatable-main-content {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 400px;
    overflow-x: auto;
    max-width: 100%;
    position: relative;
}

/* Loading State */
.datatable-loading {
    padding: 60px 24px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    min-height: inherit;
}

.loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 400px;
}

.loading-spinner .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-text h4 {
    font-size: 18px;
    color: #495057;
    margin: 0 0 8px 0;
}

.loading-text p {
    color: #6c757d;
    margin: 0;
}

/* Conteúdo da Tabela */
.datatable-content {
    background: white;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-height: inherit;
    padding: 20px 24px;
}

/* Accordion Moderno */
.modern-accordion {
    width: 100%;
}

.accordion-item {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.accordion-item:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #f8f9fa;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 1px solid #e9ecef;
}

.accordion-header:hover {
    background: #e9ecef;
}

.accordion-title {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.accordion-icon {
    font-size: 16px;
    color: #667eea;
}

.branch-name {
    font-size: 16px;
    font-weight: 600;
    color: #495057;
}

.document-count {
    background: #667eea;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
}

.accordion-toggle {
    display: flex;
    align-items: center;
}

.accordion-toggle i {
    font-size: 14px;
    color: #6c757d;
    transition: transform 0.3s ease;
}

.accordion-toggle i.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.accordion-content.active {
    max-height: 1000px;
}

.accordion-body {
    padding: 20px;
    background: white;
}

/* Grid de Documentos */
.documents-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
}

.document-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;
}

.document-item:hover {
    background: #e9ecef;
    border-color: #667eea;
}

.document-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
}

.document-icon {
    font-size: 16px;
    color: #667eea;
}

.document-title {
    font-size: 14px;
    color: #495057;
    font-weight: 500;
    line-height: 1.4;
}

.document-action {
    text-decoration: none;
}

/* Botões de ação */
.btn-action {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    text-decoration: none;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:hover {
    background: #5a6fd8;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-text {
    font-size: 13px;
}

/* Estado Vazio */
.empty-state {
    padding: 60px 20px;
    text-align: center;
    background: white;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.empty-icon {
    font-size: 48px;
    color: #adb5bd;
}

.empty-content h4 {
    font-size: 18px;
    color: #495057;
    margin: 0;
}

.empty-content p {
    color: #6c757d;
    margin: 0;
    font-size: 14px;
}

/* Footer */
.datatable-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    flex-wrap: wrap;
    gap: 16px;
    max-width: 100%;
    box-sizing: border-box;
}

.footer-left,
.footer-right {
    display: flex;
    align-items: center;
}

.footer-info {
    font-size: 13px;
    color: #495057;
    font-weight: 500;
}

/* Responsividade */
@media (max-width: 768px) {
    .my-container {
        padding: 0;
    }

    .my-header {
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        padding: 16px;
    }

    .header-left {
        width: 100%;
    }

    .datatable-content {
        padding: 16px;
    }

    .datatable-footer {
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
    }

    .footer-left,
    .footer-right {
        width: 100%;
        justify-content: center;
    }

    .accordion-header {
        padding: 12px 16px;
    }

    .accordion-body {
        padding: 16px;
    }

    .document-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .document-info {
        width: 100%;
    }

    .document-action {
        width: 100%;
    }

    .btn-action {
        width: 100%;
        justify-content: center;
    }

    .btn-text {
        display: inline;
    }
}

@media (max-width: 576px) {
    .datatable-title {
        font-size: 20px;
    }

    .records-summary {
        font-size: 12px;
        padding: 2px 8px;
    }

    .datatable-loading {
        padding: 40px 16px;
        min-height: 300px;
    }

    .datatable-content {
        min-height: 300px;
        padding: 12px;
    }

    .my-card {
        min-height: 400px;
    }

    .btn-action {
        padding: 6px 10px;
        font-size: 12px;
    }

    .accordion-header {
        padding: 10px 12px;
    }

    .branch-name {
        font-size: 14px;
    }

    .document-count {
        font-size: 11px;
        padding: 1px 6px;
    }

    .document-title {
        font-size: 13px;
    }
}

/* Animações suaves */
.accordion-item {
    animation: slideIn 0.3s ease;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.document-item {
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>
